// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLri_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.267822 10.0583C0.795244 12.0419 2.08123 13.8235 3.99922 14.9309C5.91234 16.0354 8.09203 16.2001 10.0696 15.7301L9.55197 13.7983C8.37363 14.114 7.09962 14.0726 5.9062 13.6268L11.8233 3.37802C12.8062 4.18876 13.4791 5.27152 13.7948 6.44997L15.7267 5.93233C15.1968 3.95464 13.9125 2.17909 11.9992 1.07449C10.0888 -0.0284886 7.91258 -0.199866 5.93723 0.272995L6.46016 2.20344C7.63432 1.89181 8.90269 1.93451 10.0912 2.37819L4.17424 12.6266C3.18525 11.8105 2.51021 10.7189 2.19729 9.53161L0.267822 10.0583Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLri is a generated icon component.
 */
let IconMedLri = IconMedLri_1 = class IconMedLri extends IconBaseElement {
    render() {
        return html `${IconMedLri_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLri.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconMedLri = IconMedLri_1 = __decorate([
    customElement('zui-icon-med-lri')
], IconMedLri);
export { IconMedLri };
